export function KeyIcon({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="8" cy="15" r="4" />
      <path d="M10.85 12.15L19 4" />
      <path d="M18 5l2 2" />
      <path d="M15 8l2 2" />
    </svg>
  );
}

export function PadlockIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      <circle cx="12" cy="16" r="1" />
    </svg>
  );
}

export function TimerIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l2 2" />
      <path d="M5 3l-2 2" />
      <path d="M19 3l2 2" />
      <path d="M12 5V3" />
      <path d="M10 2h4" />
    </svg>
  );
}

export function PuzzlePieceIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.452-.968-.886a1.59 1.59 0 0 0-2.982 0c-.166.434-.498.816-.968.886a.98.98 0 0 1-.837-.276l-1.611-1.611a2.407 2.407 0 0 1-.706-1.704c0-.617.236-1.234.706-1.704l1.568-1.568c.23-.23.338-.556.289-.878-.049-.322-.232-.61-.514-.791a1.59 1.59 0 0 1 0-2.706c.282-.181.465-.47.514-.791.049-.322-.059-.648-.289-.878L11.262 3.58A2.407 2.407 0 0 0 9.558 2.87c-.617 0-1.234.236-1.704.706L6.243 5.188a.98.98 0 0 0-.276.837c.07.47.452.802.886.968a1.59 1.59 0 0 1 0 2.982c-.434.166-.816.498-.886.968a.98.98 0 0 0 .276.837l1.611 1.611a2.407 2.407 0 0 0 1.704.706c.617 0 1.234-.236 1.704-.706" />
    </svg>
  );
}

export function MagnifyingGlassIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
      <path d="M11 8a3 3 0 0 0-3 3" />
    </svg>
  );
}

export function SkullIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="9" cy="12" r="1" />
      <circle cx="15" cy="12" r="1" />
      <path d="M8 20v-4a8 8 0 1 1 8 0v4" />
      <path d="M12 20v-2" />
      <path d="M8 20h8" />
    </svg>
  );
}

export function CompassIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </svg>
  );
}

export function TreasureChestIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4 10V8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
      <rect x="2" y="10" width="20" height="10" rx="2" />
      <path d="M12 10v4" />
      <circle cx="12" cy="15" r="1" />
      <path d="M2 14h20" />
    </svg>
  );
}
